import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';

// Date come le mostrava phpBB (formato del board: "d M Y, H:i").
export function phpbbDate(date) {
  return date ? dayjs(date).format('DD MMM YYYY, HH:mm') : '';
}
export function dateTime(date) {
  return date ? m("time", {
    datetime: date.toISOString()
  }, phpbbDate(date)) : null;
}

// Link al profilo: per ID (/u/123), come i redirect di RUNE-51. Senza utente (ospiti, account cancellati):
// il nome salvato o "Guest", come phpBB. Con il colore del gruppo phpBB (amministratori, moderatori, team), come
// "username-coloured" in phpBB, ovunque compaia il nome.
export function userLink(user, fallback, className) {
  if (fallback === void 0) {
    fallback = 'Guest';
  }
  if (className === void 0) {
    className = 'username';
  }
  if (!user) return m("span", {
    className: className
  }, fallback);
  const colour = user.attribute?.('phpbbColour');
  return m(Link, {
    className: className + (colour ? ' username-coloured' : ''),
    style: colour ? {
      color: '#' + colour
    } : undefined,
    href: app.route('user', {
      username: user.id()
    })
  }, user.displayName());
}

// Titolo dell'ultimo topic nell'indice: phpBB lo accorcia a una parola intera entro 22 caratteri, con " ...".
export function shortTitle(title, max) {
  if (max === void 0) {
    max = 22;
  }
  if (title.length <= max) return title;
  const cut = title.slice(0, max);
  const space = cut.lastIndexOf(' ');
  return (space > 0 ? cut.slice(0, space) : cut) + ' ...';
}

// Paginazione phpBB (10 messaggi per pagina): "1 ... 5 6 7", ogni pagina porta al suo primo messaggio.
export const POSTS_PER_PAGE = 10;
export function pageNumbers(pages) {
  if (pages <= 5) return Array.from({
    length: pages
  }, (_, i) => i + 1);
  return [1, null, pages - 2, pages - 1, pages];
}

// Forum in sola lettura (RUNE-60): i bottoni di scrittura si mostrano solo a chi può davvero usarli.
export function readOnly() {
  return !!app.forum.attribute('runeaudioReadOnly');
}